<template>
  <div id="wrap" class="out">
    <div class="anli_detail_banner">
      <img src="https://www.kingdee.com/news-static/img/anli_detail/banner.png">

      <div class="text">
        <div class="w1000">
          <h2 class="fnt_18 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">在财务智能化时代，以财务共享中心建设和财务信息智能化建设为抓手，构建互联网模式下新的财务信息化管理体系，全面助力财务管理转型。系统建设方面，以业务驱动财务为原则，招商蛇口信息化系统构建 “业、税、银、财”一体化蓝图，通过业财一体化，实现明细级数据提供财务审核，加强财务对业务的控制。</h2>
          <div class="banner-text fnt_16 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">——郝志越   招商局蛇口工业区控股有限公司财务技术总监</div>
        </div>
      </div>

    </div>
    <div class="anli_detail_tag">
      <div class="w1000">
        <div class="anli_tag_text">
          <div class="text">
            <div class="num_list">
              <div class="num_item">
                <div class="fnt_32">
                  <span>多级</span>
                </div>
                <div class="sub_text fnt_14">共享中心平台</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>2380 项</span>
                </div>
                <div class="sub_text fnt_14">会计核算项目</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>90%财务工作</span>
                </div>
                <div class="sub_text fnt_14">纳入共享中心</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anli_detail_article">
      <div class="w1000">
        <h1>招商局：多共享中心成就数字化的招商局</h1>
        <div class="detail_article">
          <div class="anli_item">
            <div class="subtitle fnt_24">客户概述</div>
            <div class="summary fnt_16">
              <p>招商局集团(简称“招商局”)是中央直接管理的国有重要骨干企业，经营总部设于香港，亦被列为香港四大中资企业之一。2017年，招商局集团各项经济指标再创新高：实现营业收入5844亿元，同比增长18%；利润总额1271亿元，同比增长14.3%，在央企中排名第二；截至2017年底，集团总资产7.3万亿元，同比增长7.8%，规模在央企中排名第一。招商局集团成为8家连续14年荣获国务院国资委经营业绩考核A级的央企之一和连续四个任期“业绩优秀企业”。 2018年发布的《财富》世界500强榜单中，招商局集团首次申请即入围，以146年的历史创造了世界500强中国企业的基业长青纪录。同时集团下属的招商银行也入围2018《财富》世界500强，招商局集团成为当之无愧的500强航母群。</p>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">业务挑战</div>
              <div class="summary fnt_16">
                <p>随着集团业态多元化拓展，业务不断做强做大，在“走出去”号召下，各板块未来境内外兼并收购业务发展需要财务提供更多元化的决策支持和高效服务。但目前集团总部和各板块的财务资源配备及职能分布受大量事务性和操作性基础工作制约，财务对经营战略和深入业务发展的支持缺乏力度，财务核心价值发挥不足，财务管理体系不能适应集团的战略要求和高速突变的市场格局。为此，财务共享服务中心是招商局快速完成从管控总部到平台总部的宏大转型的关键，只有通过建立财务共享服务中心才能突破集团转型中的瓶颈。</p>
              <p>&nbsp;</p></div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">解决方案</div>
              <div class="summary fnt_16">
                <p>招商局集团根据其多元化产业、多地域管理的现状制定了财务共享战略规划。本着充分发挥各板块的积极性，以财务共享建设为手段，按照业务领域建设多级共享中心，在统一的财务共享平台上，各板块建立统一的财务核算体系，统一的资金债务业务流程，使集团统一会计制度政策得到执行，加强集团资金债务监控，实现会计核算规范化、标准化、精细化，推动财务转型升级。目前通过两年的共享建设，以招商蛇口为共享中心建设试点单位，实现了招商蛇口共享中心，招商航筹办共享中心的共享上线运营，同时招商港口、物流板块等其他板块共享中心也在分步骤的推进财务共享中心的建设。</p>
                <p>招商局集团财务多共享中心的建设，实现一套管理机制，两大区域布局，三大类板块有序推进，两大板块内建设原则，一个共享运营平台的顶层设计理念。应用共享运营层面三大抓手流程、系统和绩效统一管理，实现集团在各运营中心的标准化管理。</p>
                <p>标准化的财务数据，为公司决策提供可靠的依据</p>
                <p>集团通过共享中心的建设，统一处理审查、记账、支付、报表等基础性会计作业，独立、自动化的账务处理，减低了差错和人为调账的风险，提高了财务数据传递的及时性和准确性。财务报告能及时、准确反应一线业务，为制定财务业务政策、编制预算提供了更为准确、可靠的依据。</p>
                <p>业财融合的共享流程，提供高质量高效率服务</p>
                <p>集团通过财务共享中心的建设，规范了集团前端月结自动计费流程。操作数据都由业务操作部在系统中进行统一录入，计费人员审核过程中如发现数据错误导致账单不正确的情况，退回业务操作部进行调整，调整后再重新对账单进行审核。AR账单管理岗按客户整理操作部提供的纸质单证，并分发给各计费人员使用，计费人员按客户进行账单审核。该流程的规划实现了统一业务和财务之间的操作，打通了业务与财务系统的对接。</p>
                <p>财务团队结构优化，发挥财务核心价值</p>
                <p>集团通过财务共享中心的建设，对财务人员进行了专业化的分工，使得更多的高端财务人员工作重点不再仅仅是做账和支付，更多的参与到预算分析、绩效管理、成本管理、税务筹划、汇率风险管理工作中。这要求实现财务与业务相结合，介入到企业的业务运作当中去，进行战略规划，帮助战略落地，也就是向管理会计转型。</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">项目价值</div>
              <div class="summary fnt_16">
                <p>招商局港口控股有限公司携手金蝶EAS，通过建立共享中心，逐步统一了会计科目和核算项目近2380 项, 统一财务政策、制度近53 项,统一了前端多个业务系统，实现了财务管理的前移，不仅只管理财务的核算，更通过EAS共享平台规范了港口的合同管理、计费规则、应收账款管理、商务管理、操作成本管理、码头操作计费系统，使共享中心成为企业财务业务一体化管理的抓手。此外，通过财务共享转型，提高管理会计比重，提高会计部门在集团中的地位，形成价值创造型财务。</p>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Successcase2',
  components: { CircleBtn },

  data() {
    return {
    }
  },
  mounted() {
    document.querySelector('#wrap').scrollIntoView(true)
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
.out {
  padding-bottom: 50px;
}
.anli_detail_banner {
    position: relative;
    overflow: hidden;
}
.anli_detail_banner img {
    width: 100%;
}
@media only screen and (max-width: 1366px){
.anli_detail_banner .text {
    top: 50%;
}
}
.anli_detail_banner .text {
    position: absolute;
    width: 100%;
    position: absolute;
    top: 55%;
    left: 0;
    transform: translateY(-50%);
    color: #fff;
    text-align: left;
}
.w1000 {
    width: 1000px;
    margin: 0 auto;
    max-width: 94%;
}
.anli_detail_banner .text h2 {
    margin-bottom: 28px;
    width: 65%;
    line-height: 1.88em;
    padding: 0 25px;
}
.anli_detail_banner .text .banner-text {
    margin-bottom: 44px;
    line-height: 1.7em;
    padding: 0 25px;
}
.anli_detail_banner .text h2:before {
    content: "";
    display: block;
    width: 41px;
    height: 34px;
    background: url(../../../assets/yinhao.png);
    opacity: 0.3;
    margin-bottom: 8px;
}
.fnt_18 {
    font-size: 18px;
}
.anli_detail_tag {
  text-align: left;
}
.anli_detail_tag .anli_tag_text {
    padding: 25px;
    background: #fff;
    font-size: 0;
    box-shadow: 1px 1px 20px 5px rgb(0 132 246 / 20%);
    transform: translateY(-50%);
}
.anli_detail_tag .anli_tag_text .img {
    /* padding: 10px; */
    border: 1px solid #eeeeed;
    display: inline-block;
    vertical-align: middle;
}
.anli_detail_tag .anli_tag_text .text {
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    color: #888888;
}
.anli_detail_tag .anli_tag_text .img img {
    width: 114px;
}
.anli_detail_tag .anli_tag_text .img .img_mobil {
    display: none;
}
.anli_detail_tag .anli_tag_text .title {
    margin-bottom: 8px;
}
.fnt_16 {
    font-size: 16px;
}
.anli_detail_tag .anli_tag_text .title span:first-child {
    font-weight: 600;
    color: #333333;
    margin-right: 20px;
}
.anli_detail_tag .anli_tag_text .text a {
    color: #888888;
}
@media only screen and (max-width: 1440px){
.fnt_24 {
    font-size: 20px;
}
}
.fnt_24 {
    font-size: 24px;
}
.num_list {
    font-size: 0;
    padding: 2.1% 0;
    text-align: center;
}
.num_item {
    display: inline-block;
    width: 33%;
    color: #888888;
    text-align: center;
    position: relative;
    vertical-align: top;
    padding: 0 10px;
}

.fnt_14 {
    font-size: 14px;
}
.num_item .fnt_32 {
    font-weight: 600;
    color: #0084f6;
}
@media only screen and (max-width: 1440px) {
.fnt_32 {
    font-size: 24px;
}
}
.anli_detail_article {
  text-align: left;
}
h2 {
  margin-bottom: 20px;
  font-size: 28px;
  line-height: 40px;
}
.subtitle {
    color: #2386ee;
    margin-bottom: 20px;
}
.fnt_24 {
    font-size: 24px;
}
.fnt_16 {
    font-size: 16px;
}
.summary p {
    margin-bottom: 1.5em;
    line-height: 2em;
    font-size: 15px;
}
h1 {
  font-size: 30px;
  text-align: center;
  margin-bottom: 10px;
}
.num_item:after {
    content: "";
    width: 1px;
    height: 80px;
    background: #e6e6e6;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.num_item:last-child:after{display: none;}
</style>>



// WEBPACK FOOTER //
// src/views/successcase/components/Merchants.vue